module.exports = __webpack_public_path__ + "images/placeholder-delay-statistics-desktop-efe73a64d5e51382de7a1a8d8ed2bb50.png";